import React from 'react';
import { BRAND } from '../brand';

/**
 * Header brand: mark + wordmark + descriptor as live text (readable at nav scale).
 */
const BrandLockup = ({ className = 'mk-brand', onClick, type = 'button', ...rest }) => {
  const Tag = type === 'button' ? 'button' : 'div';

  return (
    <Tag
      type={type === 'button' ? 'button' : undefined}
      className={className}
      onClick={onClick}
      aria-label={`${BRAND.productName} — ${BRAND.descriptor}`}
      {...rest}
    >
      <img
        className="mk-brand-mark-img"
        src={BRAND.assets.markQuartered}
        alt=""
        aria-hidden="true"
      />
      <span className="mk-brand-text">
        <strong>{BRAND.productName}</strong>
        <span>{BRAND.descriptor}</span>
      </span>
    </Tag>
  );
};

export default BrandLockup;
